import React from 'react';

import styles from './styles.module.scss';

const RateAndReviewHeader = () => (
  <div className={styles.header} data-testid="rate-and-review-header">
    <h1>Rate & Review</h1>
    <p>
      We would love to hear your thoughts!
      <span>
        Please note, you may only write one review per product. Reviews cannot be edited once
        submitted.
      </span>
    </p>
  </div>
);

export default RateAndReviewHeader;
